// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__TrroG","showSidebar":"Sidebar_showSidebar__zVgon"};